import { render, staticRenderFns } from "./layoyt-global-menu-column.vue?vue&type=template&id=44a3bc1a&scoped=true&"
import script from "./layoyt-global-menu-column.vue?vue&type=script&lang=js&"
export * from "./layoyt-global-menu-column.vue?vue&type=script&lang=js&"
import style0 from "./layoyt-global-menu-column.vue?vue&type=style&index=0&id=44a3bc1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a3bc1a",
  null
  
)

export default component.exports